<template>
    <div v-show="visible" :class="notificationBannerClass">
      <p class="notification-text">{{ text }}</p>
      <button class="close-button" @click="close">X</button>
    </div>
  </template>
  
  <script>
  export default {
    props: ['type', 'text', 'visible'],
    data() {
      return {
        isVisible: this.visible
      }
    },
    watch: {
      visible(newValue) {
        this.isVisible = newValue;
        if(newValue) {
          setTimeout(() => {
            this.isVisible = false;
            this.$emit('close');
          }, 3000);
        }
      }
    },
    methods: {
      close() {
        this.isVisible = false;
        this.$emit('close');
      }
    },
    computed: {
      notificationBannerClass() {
          if(this.type == 'success') {
              return 'notification-banner-success';
          }
          else if(this.type == 'error') {
              return 'notification-banner-error';
          }
          else{
              return 'notification-banner';
          }
      }
    },
  }
  </script>

<style scoped>
.notification-banner-success {
  background: rgba(6, 168, 33, 0.4);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  padding: 20px;
  position: relative;
  color: #fff;
  margin-bottom: 20px;
}

.notification-banner-success:hover {
    background: rgba(6, 168, 33, 0.1);
}

.notification-banner-error{
  background: rgba(240, 34, 27, 0.4);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  padding: 20px;
  position: relative;
  color: #fff;
  margin-bottom: 20px;
}

.notification-banner-error:hover {
    background: rgba(240, 34, 27, 0.1);
}


.notification-text {
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  color: #fff;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
</style>
  